var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCustomerManagement = function SvgCustomerManagement(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.25 6A2.75 2.75 0 0 1 6 3.25h12A2.75 2.75 0 0 1 20.75 6v2.25h.5a.75.75 0 0 1 0 1.5h-.5v1.5h.5a.75.75 0 0 1 0 1.5h-.5v1.5h.5a.75.75 0 0 1 0 1.5h-.5V18A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18zm16 8.25h-.5a.75.75 0 0 0 0 1.5h.5V18c0 .69-.56 1.25-1.25 1.25H6c-.69 0-1.25-.56-1.25-1.25V6c0-.69.56-1.25 1.25-1.25h12c.69 0 1.25.56 1.25 1.25v2.25h-.5a.75.75 0 0 0 0 1.5h.5v1.5h-.5a.75.75 0 0 0 0 1.5h.5zM9.75 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m3.372 1.75a2.75 2.75 0 1 0-4.244 0A4.75 4.75 0 0 0 6.25 16a.75.75 0 0 0 1.5 0 3.25 3.25 0 0 1 6.5 0 .75.75 0 0 0 1.5 0 4.75 4.75 0 0 0-2.628-4.25",
    clipRule: "evenodd"
  })));
};
export default SvgCustomerManagement;